import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.quotes.QuoteCreator.';
  public static readonly newQuote = `${Id.prefix}newQuote`;
  public static readonly shipping = `${Id.prefix}shipping`;
  public static readonly totalShippingCost = `${Id.prefix}totalShippingCost`;
  public static readonly cannotCreateQuoteNotAssignedToBranch = `${Id.prefix}cannotCreateQuoteNotAssignedToBranch`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangQuoteCreator {
  private constructor() {}
  public static newQuote(): string {
    return interpolate(Id.newQuote);
  }
  public static shipping(): string {
    return interpolate(Id.shipping);
  }
  public static totalShippingCost(): string {
    return interpolate(Id.totalShippingCost);
  }
  public static cannotCreateQuoteNotAssignedToBranch(): string {
    return interpolate(Id.cannotCreateQuoteNotAssignedToBranch);
  }
}

export class QuoteCreatorModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.newQuote, "New {{glossary 'quote'}}", 'Default title for a new quote');
    register.add(Id.shipping, 'Shipping', 'Title for shipping line item');
    register.add(Id.totalShippingCost, 'Total Shipping Cost', 'Description for shipping line item');
    register.add(
      Id.cannotCreateQuoteNotAssignedToBranch,
      "cannot create {{glossary 'quote'}} because you are not assigned to a {{glossary 'branch'}}. Please contact support",
      'Error message when user is not assigned to a branch'
    );
  }
}
